import React from 'react'
import Head from "next/head";
import IRCTC from '@/components/casestudy/IRCTC';

const irctc = () => {
    return (
        <>
            <Head>
                <title>IRCTC Pantry Services Revolutionized with Handheld Billing Solutions by QB</title>
                <link rel="canonical" href="https://queuebuster.co/casestudy/irctc" />
                <link rel="alternate" href="https://queuebuster.co/casestudy/irctc" hrefLang="en-us" />
                <meta name="description" content="Learn how IRCTC improved operational efficiency and transparency in train pantry services with handheld billing machines and printed receipts." />
                <meta property="og:title" content="How IRCTC Transformed Train Pantry Services with Handheld Billing Machines" />
                <meta property="og:description" content="Discover how IRCTC introduced handheld billing machines to revolutionize train pantry services. The move brought transparency, accountability, and efficiency, benefiting passengers, operators, and government officials through printed receipts for every transaction." />
                <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/Group+1171276118.png" />
                <meta property="og:url" content="https://queuebuster.co/casestudy/irctc" />
            </Head>
            <IRCTC />
        </>
    )
}

export default irctc
